import { NewNames as NewNamesForm } from "@bgea-js/form-templates";
import donationHeaderSpiritualBootCamp from "../../../../src/content/spiritual-boot-camp/donationHeader";
import * as React from 'react';
export default {
  NewNamesForm,
  donationHeaderSpiritualBootCamp,
  React
};